import axios from "axios"
import env from '@/environment';

const url = env.APISERVICE;

const delmondApi = axios.create({
    baseURL: `${url}`
})

delmondApi.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${localStorage.getItem('idToken')}`;
  
  // ✅ Forzar no-caché en todas las peticiones
  config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
  config.headers['Pragma'] = 'no-cache';
  
  // ✅ Timestamp único para evitar caché del service worker
  config.params = {
    ...config.params,
    _t: Date.now()
  };

  return config;
});

export default delmondApi;